import { FiArrowLeft, FiFileText } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/signin"
          className="inline-flex items-center text-sm font-medium text-orange-600 hover:text-orange-500 mb-6"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Sign In
        </Link>

        <div className="bg-white rounded-2xl p-8 card-shadow border border-gray-100">
          <h1 className="text-3xl font-bold text-gray-900">Terms & Conditions</h1>
          <p className="mt-2 text-sm text-gray-500">Contractual terms for use of the UsedAdda Agent Portal</p>
          <p className="mt-1 text-xs text-gray-500">Last updated: 21 April 2026</p>

          <div className="mt-8 space-y-6 text-sm text-gray-700 leading-7">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 inline-flex items-center">
                <FiFileText className="mr-2 h-5 w-5 text-orange-500" />
                1. Agreement to Terms
              </h2>
              <p className="mt-2">
                These Terms & Conditions form a binding agreement between MK WHEELS LLP and any user of the
                UsedAdda Agent Portal. By accessing or using this portal, you confirm that you have read,
                understood, and agreed to these terms.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">2. Eligibility and Authorized Access</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Agent accounts are intended for authorized users handling UsedAdda business workflows.</li>
                <li>You must provide accurate registration and account information at all times.</li>
                <li>We may limit, suspend, or revoke access if eligibility or policy requirements are not met.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">3. Acceptable Use and Prohibited Activities</h2>
              <ul className="mt-2 list-disc pl-5 space-y-1">
                <li>Do not upload false, misleading, illegal, or unauthorized listing data.</li>
                <li>Do not attempt to break security controls, scrape data, or disrupt platform services.</li>
                <li>Do not impersonate other users, businesses, or owners.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">4. Listing Accuracy and Documentation</h2>
              <p className="mt-2">
                Agents are responsible for ensuring vehicle details, ownership declarations, prices, and
                supporting documents are accurate and lawful. UsedAdda may remove or restrict non-compliant
                listings without prior notice.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">5. Account Security</h2>
              <p className="mt-2">
                You are responsible for all activity under your account. Keep credentials confidential and notify
                support immediately if you suspect unauthorized access.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">6. Intellectual Property</h2>
              <p className="mt-2">
                Portal software, design, branding, and content are owned by MK WHEELS LLP or its licensors.
                No part of the portal may be copied, redistributed, or reused beyond permitted operational use.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">7. Service Availability and Changes</h2>
              <p className="mt-2">
                Features may be updated, restricted, or discontinued for maintenance, business changes, or
                compliance reasons. We do not guarantee uninterrupted availability at all times.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">8. Limitation of Liability</h2>
              <p className="mt-2">
                To the extent permitted by law, MK WHEELS LLP is not liable for indirect or consequential losses
                arising from use of the portal, temporary outages, or third-party service interruptions.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">9. Governing Law and Jurisdiction</h2>
              <p className="mt-2">
                These Terms are governed by the laws of India. Disputes shall be subject to the competent courts
                in Eluru, Andhra Pradesh, unless otherwise required by applicable law.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900">10. Contact and Business Details</h2>
              <div className="mt-2 rounded-xl bg-orange-50 border border-orange-100 p-4 space-y-1 text-gray-800">
                <p><span className="font-semibold">Business Name:</span> MK WHEELS LLP</p>
                <p><span className="font-semibold">Product:</span> UsedAdda</p>
                <p><span className="font-semibold">Address:</span> 12-71/7342, NEHRU NAGAR, Near BIT-1, Eluru, Andhra Pradesh, 534001</p>
                <p><span className="font-semibold">Email:</span> support@usedadda.com</p>
              </div>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="font-medium text-orange-600 hover:text-orange-500">About Us</Link>
            <Link to="/policies" className="font-medium text-orange-600 hover:text-orange-500">Policies</Link>
            <Link to="/refund-policy" className="font-medium text-orange-600 hover:text-orange-500">Refund Policy</Link>
            <Link to="/contact" className="font-medium text-orange-600 hover:text-orange-500">Contact Details</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
